import { Button, Divider, HStack, Text, VStack } from "native-base";
import { InterfaceVStackProps } from "native-base/lib/typescript/components/primitives/Stack/VStack";
import React from "react";

import { OrderItem } from "@/interfaces/domain/Order";

import HorizontalProductList from "../HorizontalProductList";

type ProductSectionListProps<T> = {
  title: string;
  data: T;
  isLoading: boolean;
  showDivider?: boolean;
  onSelect: (productId: string) => void;
  onPressViewMore: () => void;
} & InterfaceVStackProps;

const ProductSectionList = <T extends OrderItem[]>({
  data,
  isLoading,
  showDivider = true,
  onPressViewMore,
  onSelect,
  title,
  ...props
}: ProductSectionListProps<T>) => {
  return (
    <VStack key={title} my="4" mx="1" p="4" bgColor="white.50" shadow="4" rounded="lg" {...props}>
      <HStack justifyContent="space-between" alignItems="center" mb={!showDivider ? 1 : 0}>
        <Text fontSize="xl" color="text.600" bold>
          {title}
        </Text>
        <Button variant="ghost" onPress={onPressViewMore} _text={{ fontSize: "md" }}>
          Ver mais
        </Button>
      </HStack>
      {showDivider && <Divider my="4" />}
      <HorizontalProductList data={data} isLoading={isLoading} onSelect={onSelect} />
    </VStack>
  );
};

export default ProductSectionList;
